import { PREFIX_OF_TEMP_NODE, KEYS_OF_WITHOUT_OPTIONS } from '../Component/Flow/constant'

/**
 * Survey Utility Functions
 * Helper functions for survey data transformation and validation
 */

/**
 * Sort questions by sequence
 */
export const sortQuestionsBySequence = (questions = []) => {
  return questions.sort((a, b) => a.sequence - b.sequence)
}

/**
 * Format survey data for API submission
 */
export const formatSurveyForSubmission = (surveyFlow, nodes, edges) => {
  const payload = {
    ...surveyFlow,
    questionList: nodes
      .map((node) => {
        const newData = {
          ...node?.data,
          sequence: Number.isNaN(Number(node?.data?.sequence))
            ? 10
            : Number(node?.data?.sequence),
          nextQuestionMap: null,
          parentQuestionId: null,
        }

        // Remove temp node IDs
        if (newData?.id && String(newData?.id).startsWith(PREFIX_OF_TEMP_NODE)) {
          delete newData?.id
        }

        // Remove answer options for types that don't need them
        if (KEYS_OF_WITHOUT_OPTIONS.includes(newData?.type)) {
          newData.answerOptionList = null
        }

        return newData
      })
      .sort((first, second) => first?.sequence - second.sequence),
  }

  // Remove temp node ID from survey if present
  if (payload?.id && String(payload?.id).startsWith(PREFIX_OF_TEMP_NODE)) {
    delete payload?.id
  }

  return payload
}

/**
 * Check if survey has unsaved changes
 */
export const hasSurveyChanges = (original, current) => {
  return JSON.stringify(original) !== JSON.stringify(current)
}

/**
 * Extract survey metadata from survey data
 */
export const extractSurveyMetadata = (survey) => {
  return {
    id: survey?.id,
    title: survey?.title,
    description: survey?.description,
    remarks: survey?.remarks,
    status: survey?.status,
  }
}

/**
 * Map survey status to display label
 */
export const getSurveyStatusLabel = (status) => {
  const labels = {
    A: 'Active',
    P: 'Paused',
    D: 'Deleted',
  }
  return labels[status] || status
}

/**
 * Check if survey can be edited
 */
export const canEditSurvey = (status) => {
  return status !== 'D' // Can't edit deleted surveys
}

/**
 * Check if survey can be deleted
 */
export const canDeleteSurvey = (status) => {
  return true // Can delete any survey
}

/**
 * Validate survey data before submission
 */
export const validateSurveyData = (data) => {
  const errors = {}

  if (!data.title || typeof data.title !== 'object') {
    errors.title = 'Title is required'
  } else {
    const langs = Object.values(data.title)
    if (langs.every((lang) => !lang)) {
      errors.title = 'At least one language title is required'
    }
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  }
}

/**
 * Parse survey list response and extract relevant data
 */
export const parseSurveyListResponse = (response) => {
  return {
    items: response?.data || [],
    total: response?.count || 0,
  }
}
